import japanese from "./locales/ja.js";
import { translate as viewerTranslate } from "../ui/i18n.js";
export { loadLanguage, saveLanguage, LANGUAGE_KEY } from "../ui/i18n.js";

const patterns = Object.entries(japanese).filter(([key]) => key.includes("{")).map(([key, value]) => {
    const names = [];
    const expression = key.split(/(\{\w+\})/).map(part => {
        if (/^\{\w+\}$/.test(part)) { names.push(part.slice(1, -1)); return "(.+?)"; }
        return part.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }).join("");
    return { regex: new RegExp(`^${expression}$`), names, value };
});

// Only UI-owned strings pass through this function. User-authored names, model
// paths, clip names and serialized State values are never translated.
export function translate(language, value, parameters) {
    if (typeof value !== "string") return value;
    if (value.includes("\n") && !parameters) return value.split("\n").map(line => translate(language, line)).join("\n");
    const key = value.replace(/\s+/g, " ").trim();
    let result = language === "ja" ? (Object.hasOwn(japanese, key) ? japanese[key] : undefined) : value;
    if (language === "ja" && result === undefined && !parameters) {
        for (const pattern of patterns) {
            const match = key.match(pattern.regex);
            if (match) return pattern.value.replace(/\{(\w+)\}/g, (_, name) => match[pattern.names.indexOf(name) + 1]);
        }
    }
    result = result ?? viewerTranslate(language, value, parameters);
    return parameters ? result.replace(/\{(\w+)\}/g, (token, name) => parameters[name] ?? token) : result;
}
